import Vue from "vue";

function add0(m) {
	return m < 10 ? '0' + m : m
}

export const getTime = (ns) =>{
	var date = new Date(); //新建时间对象
	var nian = date.getFullYear(); //获取年
	var yue = date.getMonth() + 1; //获取月
	var ri = date.getDate(); //获取日
	var xq = date.getDay(); //获取星期 
	var xs = date.getHours(); //获取小时
	var fz = date.getMinutes(); //获取分钟
	var m = date.getSeconds(); // 获取秒
	var sd;
	var weekday = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
	//判断上下午
	if (xs > 12) {
		sd = "pm";
	} else if (xs < 12) {
		sd = "am";
	}
	//12小时制
	// if (xs > 12) {
	// 	xs = xs - 12;
	// }
	//补0
	if (xs < 10) {
		xs = "0" + xs;
	}
	if (m < 10) {
		m = "0" + m;
	}
	if (fz < 10) {
		fz = "0" + fz;
	}
	//页面输出
	let str=`<span>${nian}年${yue}月${ri}日</span><span>${weekday[xq]}</span><span>${xs}:${fz}:${m}</span>`;
	return str
}
//时间戳转时间
export const timestampToDate = (ns) => {
	var time = new Date(ns);
	var y = time.getFullYear()
	var m = time.getMonth() + 1
	var d = time.getDate()
	var h = time.getHours()
	var mm = time.getMinutes()
	var s = time.getSeconds()
	return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ":" + add0(s)
}

/**
 * 获取时间戳
 */
export const getTimestamp = function() {
	const timestamp = new Date().getTime();
	return timestamp;
}
/* js日期 根据时间戳获取以下格式
  几年前
  几个月前
  几小时前 
  几分钟前*/
export const dataDiff = function(hisTime, nowtime, hisTimeS) {
	let now = nowtime ? nowtime : new Date().getTime();
	let diffValue = now - hisTime;
	let result = "";
	let minite = 1000 * 60;
	let hour = minite * 60;
	let day = hour * 24;
	let halfMonth = day * 15;
	let month = day * 30;
	let year = month * 12
	let _year = diffValue / year
	let _month = diffValue / month
	let _day = diffValue / day
	let _hour = diffValue / hour
	let _min = diffValue / minite;
	// if (_year >= 1) result = parseInt(_year) + '年前';
	// else if (_month >= 1) result = parseInt(_month) + '个月前';
	if (_day >= 1) {
		if (_day > 7) {
			result = hisTimeS
		} else {
			result = parseInt(_day) + '天前'
		}
	} else if (_hour >= 1) result = parseInt(_hour) + '个小时前';
	else if (_min >= 1) result = parseInt(_min) + '分钟前';
	return result
}

export const temData=[
	{
		num: 5,
		lnglat: [106.901367, 34.905904],
		equipment: [{
				num: 5,
				equipment: [],
				id: 456132016513213,
				status: "0", //异常0 正常1
				statusName: "正常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 8458,
				highload: 4555
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			// 这里的id，是用于做点击标记点做下一步处理的，如果不需要可以删除
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
		],
		id: 456132016513213,
	},
	{
		num: 26,
		lnglat: [109.901367, 34.905904],
		equipment: [{
				num: 5,
				equipment: [],
				id: 456132016513213,
				status: "0", //异常0 正常1
				statusName: "正常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 8458,
				highload: 4555
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			// 这里的id，是用于做点击标记点做下一步处理的，如果不需要可以删除
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
			{
				num: 26,
				id: 456132016513213,
				status: "1", //异常0 正常1
				statusName: "异常",
				specifications: "10路",
				servicesNum: 10,
				powerNum: 84558,
				highload: 455
			},
		],
	},
	{
		lnglat: [112.901367, 34.905904],
	},
	{
		lnglat: [118.118547, 24.475637],
	},
	// 这里的id，是用于做点击标记点做下一步处理的，如果不需要可以删除
	{
		lnglat: [118.081211, 24.493369],
	},
	{
		lnglat: [118.08885, 24.494072],
		num: 26,
	},
	{
		lnglat: [118.09503, 24.48962],
		num: 26,
	},
	{
		lnglat: [118.102926, 24.48837]
	},
	{
		lnglat: [118.08679, 24.485402]
	},
	{
		lnglat: [118.081941, 24.485909]
	},
	{
		lnglat: [118.090137, 24.476614]
	},
	{
		lnglat: [118.094171, 24.475598]
	},
	{
		lnglat: [118.089794, 24.472708]
	},
	{
		lnglat: [118.094987, 24.480051]
	},
	{
		lnglat: [118.083614, 24.47802]
	},
	{
		lnglat: [118.09606, 24.48298]
	},
	{
		lnglat: [118.10181, 24.478215]
	},
	{
		lnglat: [118.083829, 24.477864]
	},
	{
		lnglat: [118.137158, 24.451969]
	},
	{
		lnglat: [118.144797, 24.452047]
	},
	{
		lnglat: [118.14351, 24.445562]
	},
	{
		lnglat: [118.114928, 24.446812]
	},
	{
		lnglat: [118.106879, 24.453121]
	},
	{
		lnglat: [118.103618, 24.455934]
	},
	{
		lnglat: [118.114261, 24.457731]
	},
	{
		lnglat: [118.12184, 24.457445]
	},
	{
		lnglat: [118.13044, 24.456637]
	},
	{
		lnglat: [118.112738, 24.446725]
	},
	{
		lnglat: [118.104035, 24.442895]
	},
	{
		lnglat: [118.12364, 24.444474]
	},
	{
		lnglat: [118.12673, 24.443168]
	},
]
export const globalEvt = new Vue();
